import moment from 'moment';
import covidChart from './covidChart.vue';
export default {
  props: ['has_chart'],
  name: 'sscovid',
  

  components: {
    covidChart
  },

  data: function () {
    return{
      current:'',
      date:'',
      historic:'',
      yesterday: '',
      chart:'',
      chart_options:{
        responsive: true,
        maintainAspectRatio: false,
        legend:false,
        scales: {
          xAxes: [{
            display: false
          }]
        }
      },
    }
  },
  

  created: function () {
    this.get_data()
  },

  methods:{

    get_data(){

      this.$http.get('https://api.covidtracking.com/v1/states/az/current.json').then((response) => {
        this.current = response.data;
        this.date = moment(this.current.date, 'YYYYMMDD');
      }).catch(error => {
        console.log(error.message)
      });

      this.$http.get('https://api.covidtracking.com/v1/states/az/daily.json').then((response) => {
        this.historic = response.data;
        this.yesterday = this.historic[1];
        this.prepare_chart();
      }).catch(error => {
        console.log(error.message)
      });
    },

    prepare_chart(){
      let labels = [];
      let data = [];

      if(this.historic.length>0){
      
      this.historic.reverse();    
      this.historic.forEach(element => {
        let date = moment(element.date, 'YYYYMMDD');
        labels.push(date.format('MM/DD/YYYY'))
        data.push(element.positive)
      });

      this.chart = {
        labels: labels,
        datasets: [
          {
            label:'Confirmed Cases',
            borderColor: "#005cb9",
            borderDash: [0, 0],
            backgroundColor: "#005cb9",
            pointBackgroundColor: "#005cb9",
            pointBorderColor: "#005cb9",
            pointHoverBackgroundColor: "#005cb9",
            pointHoverBorderColor: "#005cb9",
            data: data,
            fill: false,
            
          } 
        ]
      }
        console.log(this.chart);
      }


    }

  },

  watch: {
  }

}